import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { NavigationButton, UserAccountButton } from 'components/elements/navigation';
import { useIconTabs } from 'hooks';
import { routes } from 'const';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function IconTabs() {
  const classes = useStyles();
  const { data: tabs } = useIconTabs();

  const Tabs = () =>
    tabs.map(({ icon, link, label, count }) => (
      <NavigationButton classes={classes.iconTab} key={link} icon={icon} link={link} label={label} count={count} isSecureMessages={link === routes.messages} />
    ));

  return (
    <div data-testid="icon-tabs" className={classes.iconTabs}>
      <Tabs />
      <UserAccountButton classes={classes.userIcon} />
    </div>
  );
}

export default IconTabs;
